import React, { useState, useMemo } from 'react';
import { styled } from '@compiled/react';
import type { Condition } from '../../../../../../../common/types';
import { ConditionHeader } from '../../../../../../../common/ui/conditions/condition-header';
import { useFormContext } from '../../../../../../../controllers/form/index.tsx';
import { SelectedConditions } from './fields/selected-condition/index.tsx';
import { NewConditions } from './main';
import { filterConditionsList } from './utils';

type Props = {
	selectedConditions: Condition[];
	conditionsList: Condition[];
	listName: string;
};

export const ConditionView = ({ conditionsList, selectedConditions, listName }: Props) => {
	const [, { setFormStatusToDirty }] = useFormContext();
	const [newConditionsList, setNewConditionsList] = useState<Condition[]>(selectedConditions);

	const selectCondition = (condition: Condition) => {
		setNewConditionsList([...newConditionsList, condition]);
		setFormStatusToDirty();
	};

	const onRemoveCondition = (conditionId: string) => {
		setNewConditionsList([
			...newConditionsList.filter((condition) => condition.conditionId !== conditionId),
		]);
		setFormStatusToDirty();
	};

	const filteredConditionsList = useMemo(
		() => filterConditionsList(conditionsList, newConditionsList),
		[conditionsList, newConditionsList],
	);

	return (
		<div
			data-test-id={`servicedesk-sla-settings.ui.metrics.metric.editable.form.conditions.condition-${listName}`}
		>
			<ConditionHeader listName={listName} />

			<Row>
				<SelectedConditions
					conditions={newConditionsList}
					onRemove={onRemoveCondition}
					listName={listName}
				/>
			</Row>
			<NewConditions
				conditionsList={filteredConditionsList}
				onConditionSelect={selectCondition}
				showLabel={Boolean(newConditionsList.length)}
				listName={listName}
			/>
		</div>
	);
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Row = styled.div({
	borderRadius: '3px',
	flexDirection: 'row',
});
